import { render } from "./FinancialGoalsPage.vue?vue&type=template&id=dc062a0a&scoped=true&ts=true"
import script from "./FinancialGoalsPage.vue?vue&type=script&lang=ts"
export * from "./FinancialGoalsPage.vue?vue&type=script&lang=ts"

import "./FinancialGoalsPage.vue?vue&type=style&index=0&id=dc062a0a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dc062a0a"]])

export default __exports__